import { Component, OnInit } from '@angular/core';
import { Organization } from 'src/app/models';
import { OrganizationService } from 'src/app/services';

@Component({
  selector: 'app-toggle-sidebar',
  templateUrl: './toggle-sidebar.component.html',
  styleUrls: ['./toggle-sidebar.component.css']
})
export class ToggleSidebarComponent implements OnInit {

  toggleOpen: boolean = false

  org: Organization

  constructor(
    private _organizationService: OrganizationService,
    ) { }

  ngOnInit(): void {
    this._organizationService.workSub.subscribe(
      (res: Organization) => {
        if(res) {
          this.org = res
        }
      }
    )
  }

}
